import React from "react";
import { useLocation } from "react-router-dom";
import { LocationOn, Email, Phone,ContactPhone ,PhoneInTalk} from "@mui/icons-material";
import { Box } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/images/stsnlogo.png"; // main logo
import leaf from "../assets/images/leaf.png"; // fallback logo
import { districtTamilNames } from "../utils/formDataUtils";
import stsnlogo from "../assets/images/stsnlogo.png"

function Footer() {
  const { user } = useAuth();
  const location = useLocation();

  // Extract district from URL
  const pathParts = location.pathname.split("/");
  const currentDistrict = pathParts[1] || null;

  const districtTamil =
    currentDistrict && districtTamilNames[currentDistrict]
      ? districtTamilNames[currentDistrict]
      : null;
      const handleContactSupport = () => {
    // Open Gmail web interface with pre-filled email
    // const subject = encodeURIComponent('Account Access Request');
    // const body = encodeURIComponent('Hello,\n\nI need help with accessing my account.\n\nThank you.');
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=cnimavt.senaithalaivarsangam@gmail.com`;
    window.open(gmailUrl, '_blank');
  };

  return (
    <>
      {/* Footer Main Section */}
      <div className="bg-gradient-to-br from-white via-[#FFF9C4] to-[#FDF5A6] text-black py-10 px-6">
        <div className="max-w-5xl mx-auto flex flex-col items-center text-center space-y-10">
          {/* Logo & Title Section */}
          <div
            className="flex items-center gap-4 cursor-pointer transition-transform hover:scale-105 hover:-translate-y-1 duration-300"
         
          >
            {/* CASE: Before Login → Tamil Nadu + leaf logo */}
            {!user ? (
              <>
                <img
                  src={stsnlogo}
                  alt="Footer Logo"
                  className="w-20 h-auto object-contain"
                />
                <Box
                  sx={{
                    color: "#E52029",
                    fontWeight: 700,
                    fontSize: "20px",
                    textAlign: "left",
                    lineHeight: 1.3,
                  }}
                >
                  தமிழ்நாடு சேனைத்தலைவர்
                  <br />
                  மகாஜன சங்கம்
                </Box>
                   <img
                  src={leaf}
                  alt="Footer Logo"
                  className="w-20 h-auto object-contain"
                />
              </>
            ) : (
              <>
                {currentDistrict ? (
                  <>
                    {/* District footer */}
                    <img
                      src={logo}
                      alt="District Footer Logo"
                      className="w-20 h-auto object-contain"
                    />
                    <Box
                      sx={{
                        color: "#E52029",
                        fontWeight: 700,
                        fontSize: "20px",
                        textAlign: "left",
                        lineHeight: 1.3,
                      }}
                    >
                      {districtTamil} மாவட்ட சேனைத்தலைவர்
                      <br />
                      சங்கம்
                    </Box>
                  </>
                ) : (
                  <>
                    {/* After login but no district → fallback to Tamil Nadu + leaf */}
                    <img
                      src={leaf}
                      alt="Footer Logo"
                      className="w-20 h-auto object-contain"
                    />
                    <Box
                      sx={{
                        color: "#E52029",
                        fontWeight: 700,
                        fontSize: "20px",
                        textAlign: "left",
                        lineHeight: 1.3,
                      }}
                    >
                      தமிழ்நாடு சேனைத்தலைவர்
                      மகாஜன சங்கம்
                    </Box>
                        <img
                      src={leaf}
                      alt="Footer Logo"
                      className="w-20 h-auto object-contain"
                    />
                  </>
                )}
              </>
            )}
          </div>

          {/* Contact Information */}
          <div className="flex flex-col md:flex-row justify-center items-center gap-6">
            {/* Location */}
            <div className="flex items-center bg-white/70 rounded-lg p-3 shadow-md w-64 cursor-pointer transition-transform hover:scale-105 hover:-translate-y-1 duration-300">
              <LocationOn className="text-red-500 w-5 h-5" />
              <span className="ml-2 text-sm">Project Office, Chennai.</span>
            </div>

            {/* Email */}
            {/* <div className="flex items-center bg-white/70 rounded-lg p-3 shadow-md w-64 cursor-pointer transition-transform hover:scale-105 hover:-translate-y-1 duration-300">
              <Email className="text-red-500 w-5 h-5" />
              <p
              onClick={handleContactSupport}
                className="ml-2 text-sm break-all hover:underline hover:text-red-600"
              >
                cnimavt.senaithalaivarsangam@gmail.com
              </p>
            </div> */}

            {/* Phone */}
            <div className="flex items-center bg-white/70 rounded-lg p-3 shadow-md w-64 cursor-pointer transition-transform hover:scale-105 hover:-translate-y-1 duration-300">
              <Phone className="text-red-500 w-5 h-5" />
              <span className="ml-2 text-sm">+91 9841818740</span>
            </div>
             {/* Phone */}
            <div className="flex items-center bg-white/70 rounded-lg p-3 shadow-md w-64 cursor-pointer transition-transform hover:scale-105 hover:-translate-y-1 duration-300">
              <ContactPhone className="text-red-500 w-5 h-5" />
              <span className="ml-2 text-sm">044 2834 0028</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <footer className="bg-[#FAD707] text-black py-3 text-center text-xs">
        <div className="max-w-5xl mx-auto">
          <span>
            ©2025 Tamil Nadu Senaithalaivar Mahajana Sangam. All Rights Reserved.
          </span>
        </div>
      </footer>
    </>
  );
}

export default Footer;
